import { debounce } from "lodash";
import { mapGetters } from "vuex";

import TooltipLayout from "@/components/atoms/tooltip-layout/index.vue";

export default {
    name: "header-navigation",
    data() {
        return {
            hiddenNavigation: [],
        };
    },
    components: {
        TooltipLayout,
    },
    watch: {
        isCourseRoute() {
            setTimeout(() => {
                this.handleResize();
            }, 1);
        },

        navigation() {
            this.handleResize();
        },
    },
    computed: {
        ...mapGetters({
            system_navigation: "system/navigation",
            courseNavigation: "courses/components",
            setting: "setting/setting",
        }),
        navigation() {
            const link =
                this.setting && this.setting.storeLink
                    ? this.setting.storeLink
                    : "https://genius.space/nashi-programmy-obucheniya/";
            return [
                {
                    title: "myCourses",
                    to: "courses",
                    type: "internal",
                },
                {
                    title: "shop",
                    to: link,
                    type: "external",
                },
            ];
        },
        isCourseRoute() {
            return this.$route.fullPath.includes("/courses/");
        },
        courseNavigationItems() {
            return Object.values(this.courseNavigation);
        },
    },
    mounted() {
        window.addEventListener("resize", debounce(this.handleResize, 500), true);
        this.handleResize();
    },
    methods: {
        changeShowNavItems(index, status) {
            if (!this.navigation) return;

            const widthWindow = document.body.offsetWidth;
            const headerLeftWidth =
                document.querySelector(".header-left").offsetWidth + 30; // 30 - padding left header
            const headerRightWidth =
                document.querySelector(".header-right").offsetWidth + 30; // 30 - padding right header
            const totalWidthPertsHeader = headerLeftWidth + headerRightWidth;
            const differenceHeaderWith = widthWindow - totalWidthPertsHeader;
            if (status) {
                if (differenceHeaderWith < 100 && widthWindow > 900) {
                    this.hiddenNavigation.unshift(this.navigation[index]);
                    this.navigation[index].hide = status;
                }
            } else {
                if (differenceHeaderWith > 100 && widthWindow > 900) {
                    this.navigation[index].hide = status;
                } else {
                    this.hiddenNavigation.push(this.navigation[index]);
                }
            }
        },
        handleResize() {
            const widthWindow = document.body.offsetWidth;
            const headerLeftWidth =
                document.querySelector(".header-left").offsetWidth + 30; // 30 - padding left header
            const headerRightWidth =
                document.querySelector(".header-right").offsetWidth + 30; // 30 - padding right header
            const totalWidthPertsHeader = headerLeftWidth + headerRightWidth;
            const differenceHeaderWith = widthWindow - totalWidthPertsHeader;

            this.hiddenNavigation = [];

            if (differenceHeaderWith < 100 && widthWindow > 900) {
                for (let i = this.navigation.length - 1; i >= 0; i--) {
                    setTimeout(() => {
                        this.changeShowNavItems(i, true);
                    }, 1);
                }
            } else {
                for (let i = 0; i <= this.navigation.length - 1; i++) {
                    setTimeout(() => {
                        this.changeShowNavItems(i, false);
                    }, 1);
                }
            }
        },
    },
};
